const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  MANAGEMENT: '/management',
  MENLOSHOPS: '/menloshops',
};

export const paths = {
  // AUTH
  auth: {
    login: `${ROOTS.AUTH}/jwt/login`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    franchisees: {
      verification: `${ROOTS.DASHBOARD}/franchisees/verification`,
    },
    panel: {
      root: `${ROOTS.DASHBOARD}/panel`,
    },
    sales: {
      root: `${ROOTS.DASHBOARD}/sales`,
    },
    finance: {
      root: `${ROOTS.DASHBOARD}/finance`,
    },
    analytics: {
      root: `${ROOTS.DASHBOARD}/analytics`,
    },
    calendar: {
      root: `${ROOTS.DASHBOARD}/calendar`,
    },
  },
  // MANAGEMENT
  management: {
    user: {
      root: `${ROOTS.MANAGEMENT}/user`,
    },
    shops: {
      root: `${ROOTS.MANAGEMENT}/shops`,
    },
  },
  // Menlo Shops
  menloShops: {
    products: {
      root: `${ROOTS.MENLOSHOPS}/products`,
      details: (id: string) => `${ROOTS.MENLOSHOPS}/products/${id}`,
    },
    campaigns: {
      root: `${ROOTS.MENLOSHOPS}/campaigns`,
    },
    checkout: {
      root: `${ROOTS.MENLOSHOPS}/checkout`,
    },
    orders: {
      root: `${ROOTS.MENLOSHOPS}/orders`,
      details: (id: string) => `${ROOTS.MENLOSHOPS}/orders/${id}`,
    },
    pending: {
      root: `${ROOTS.MENLOSHOPS}/pending`,
      details: (id: string) => `${ROOTS.MENLOSHOPS}/pending/${id}`,
    },
  },
};
